import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Typography } from "@mui/material";
import { useUserContext } from "@/providers/contexts";
import { Button, Container, Box } from "@/components/atoms";

export const MembershipSuccessPage = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { refetchUser } = useUserContext();

  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading",
  );

  const prevMembership = localStorage.getItem("prevMembershipName");

  useEffect(() => {
    const handleRedirect = async () => {
      const redirectPath = params.get("redirect") || "profile";

      const fetched = await refetchUser();

      if (
        fetched &&
        fetched.membership_type &&
        fetched.membership_type.name.toLowerCase() !==
          prevMembership?.toLowerCase()
      ) {
        localStorage.removeItem("prevMembershipName");
        setStatus("success");

        setTimeout(() => navigate(`/${redirectPath}`), 2000);
      } else {
        // Special case: Downgrade to basic (no Stripe session involved)
        if (
          prevMembership?.toLowerCase() !== "basic" &&
          fetched?.membership_type?.name?.toLowerCase() === "basic"
        ) {
          localStorage.removeItem("prevMembershipName");
          setStatus("success");
          setTimeout(() => navigate(`/${redirectPath}`), 2000);
        } else {
          setStatus("error");
        }
      }
    };

    handleRedirect();
  }, []);

  return (
    <Container componentName="membership-success-page">
      <Box
        componentName="memberships-success-parent"
        border={false}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mt: 10,
        }}
      >
        {status === "loading" && (
          <Typography variant="h5" color="text.primary">
            Verifying your membership...
          </Typography>
        )}
        {status === "success" && (
          <>
            <Typography variant="h4" color="success.main" gutterBottom>
              Membership Updated!
            </Typography>
            <Typography variant="body1">
              Redirecting you to your profile...
            </Typography>
          </>
        )}
        {status === "error" && (
          <>
            <Typography variant="h4" color="error.main" gutterBottom>
              Something went wrong
            </Typography>
            <Typography variant="body1">
              We couldn’t verify your membership update. Please try again or
              contact support.
            </Typography>
            <Box
              componentName="memberships-success-return"
              border={false}
              mt={2}
            >
              <Button
                componentName="return-memberships-button"
                variant="contained"
                color="primary"
                onClick={() => navigate("/memberships")}
              >
                Return to Memberships
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Container>
  );
};
